import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import jwt_decode from "jwt-decode";

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (

        (localStorage.getItem("token") != null && jwt_decode(localStorage.getItem("token")).exp > Date.now()) 

        ? <Component {...props}  {...rest}/>
        : <Redirect to='/sign-in' />
    )} />
  )

  export default PrivateRoute;
